<div class="ui-doc-upload">
  <div
    *ngIf="!disabled"
    class="ui-doc-upload__zone"
    (click)="onBrowseClick(fileInput)">
    <mat-icon class="ui-doc-upload__icon">cloud_upload</mat-icon>
    <p class="ui-doc-upload__title">Click to upload documents</p>
    <span class="ui-doc-upload__hint">PDF, images, and other supported files</span>
  </div>

  <input
    #fileInput
    type="file"
    class="ui-doc-upload__input"
    [multiple]="multiple"
    [accept]="accept"
    [disabled]="disabled"
    (change)="onFilesSelected($event)" />

  <div class="ui-doc-upload__list" *ngIf="files?.length > 0">
    <div class="ui-doc-upload__item" *ngFor="let file of files; let i = index">
      <mat-icon class="ui-doc-upload__item-icon">insert_drive_file</mat-icon>
      <span class="ui-doc-upload__item-name">{{ file.name }}</span>
      <button
        *ngIf="!disabled"
        type="button"
        mat-icon-button
        class="ui-doc-upload__remove"
        (click)="onRemove(i)"
        aria-label="Remove file">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <button
    *ngIf="showViewLink && files?.length > 0"
    type="button"
    class="ui-doc-upload__view-link"
    (click)="onViewFiles()">
    {{ viewLinkLabel }}
  </button>
</div>
